import React, { forwardRef, useImperativeHandle, useContext, useEffect, useState, useRef } from "react";
import { Popover, Modal, message, Divider, Input, TabsProps, Tabs, ConfigProvider, Button } from "antd";
import LOGO from "@/assets/images/logo.png";
// import PAY_COUNT from "@/assets/images/payCount.svg";
import PAY from "@/pages/Price/image/pay.png";
import AVATOR from "@/assets/images/avator.svg";
import { DataContext } from "@/context";
import IVITE_USER from "@/assets/images/header/invite_user.png";
import ACTIVATE_VIP from "@/assets/images/header/activate-vip-img.svg";
// import USER_VIP_BG from "@/assets/images/header/user_vip_bg.png";
import MessageIcon from "@/assets/images/header/系统通知 (1).svg";

import { debounce } from "lodash";
import { usePostHog } from 'posthog-js/react';
import { Dialog } from 'antd-mobile'

import Login from "./Login";
import Register from "./Register";

import eventBus from "@/event/event";
import { useLocation, useNavigate } from 'react-router-dom';
import { detectDevice } from '@/utils'
import { List, Popup, Dropdown } from 'antd-mobile'
import { MenuUnfoldOutlined } from '@ant-design/icons';
// import { recordClickType } from "@/apis/record";
// import { clickTypeMapper } from '@/config/constent';
import dayjs from 'dayjs'

import "./styles.scss";
import { ComputeUsageModal } from "../ComputeUsageModal/ComputeUsageModal";
import { BuyComputeModal } from "../BuyComputeModal/BuyComputeModal";
import { postCode } from "@/apis/vip";

interface Props {
  ref?: any;
  cssStyle?: React.CSSProperties;
  userOtherInfo: any;
  payCountObj: any;
}
const USER_VIP_BG = 'https://cemeta-resource-dev-1313090634.cos.ap-beijing.myqcloud.com/1/20250901141919181433/cca55482-ab80-42d8-90da-1906779bb2f1.png'
const BROARD_LINK = 'https://mi8elatzm1x.feishu.cn/wiki/OxyTw5WjqiqhgykN6bHcJZtxnRg?table=tblW4jUgv0eRYdSS&view=vewi8cd7P3'
const LESSON_LINK = 'https://mi8elatzm1x.feishu.cn/wiki/SfaxwB67JiEoHAkvpf1cVUfInVf?from=from_copylink'

const Header: React.FC<Props> = forwardRef((props: Props, ref: any) => {
  const [messageApi, contextHolder] = message.useMessage();
  const { cssStyle = {}, userOtherInfo, payCountObj } = props;
  const {
    userInfo,
    setContextValue
} = useContext(DataContext);
  const posthog = usePostHog();
  const location = useLocation();
  const navigate = useNavigate();
  const macRef = useRef<HTMLAnchorElement | null>(null);
  const winRef = useRef<HTMLAnchorElement | null>(null);
  const [open, setOpen] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [showPrice, setShowPrice] = useState(true);
  const [subscriptionOpen, setSubscriptionOpen] = useState(false)
  const [rightsRedemptionOpen, setRightsRedemptionOpen] = useState(false)
  const [rightsCode, setRightsCode] = useState('')

  const [buyComputeOpen, setBuyComputeOpen] = useState(false)
  const [computeUsageOpen, setComputeUsageOpen] = useState(false)

  const [tabKey, setTabKey] = useState('subscribe')

  const isPc = detectDevice()
  const [moreVisible, setMoreVisible] = useState(false)
  const headerRight = useRef(null)
  const headerLeft = useRef(null)

  const tabsOnChange = (val: string) =>{
    setTabKey(val)
  }


  const openLogin = (or: boolean = true) => {
    handleShowLogin(or)
  }
  useImperativeHandle(ref, () => ({
    openLogin: openLogin,
  }));


  const handleShowLogin = (or) => {
    setIsLogin(or);
    setOpen(true);
  };

  const handleLogOut = () => {
    // recordClickType({
    //   event_name: clickTypeMapper.CEMETA_LOGOUT
    // }).catch((err) => {
    //   console.error('err', err)
    // })
    posthog?.capture('haohui_logout', {
      type: 'pc',
      info: navigator?.userAgent
    });

    eventBus.emit('logout');
  }

  const handleJumpLink = () => {
    navigate('/price');
  }

  const onOpenBuyCompute = () => {
    setBuyComputeOpen(true)
  }

  const onOpenComputeUsage = () => {
    setComputeUsageOpen(true)
  }
  const onCancelComputeUsage = () => {
    setComputeUsageOpen(false)
  }

  const onOpenSubscription = () => {
    setSubscriptionOpen(true)
  }
  const onCancelSubscription = () => {
    setSubscriptionOpen(false)
  }
  const onOpenRights = () => {
    setRightsRedemptionOpen(true)
  }
  const onCancelRights = () => {
    setRightsRedemptionOpen(false)
  }

  const exchange = async() =>{
    try {
        await postCode({
            code: rightsCode
        }).then(() => {
            setRightsCode('')
            message.success( "兑换成功" )
        })
    } catch(e) {
      message.error(e)
    }
  }
  
  const handleOpenCompute = debounce(() => {
    if (userInfo?.user_id) {
      onOpenBuyCompute()
    } else {
      openLogin(); // 触发子组件按钮点击
    }
  }, 300)

  const handleOpen3 = debounce(() => {
    if (userInfo?.user_id) {
      onOpenComputeUsage()
    } else {
      openLogin(); // 触发子组件按钮点击
    }
  }, 300)

  const handleOpenubscription = debounce(() => {
    if (userInfo?.user_id) {
      onOpenSubscription()
    } else {
      openLogin(); // 触发子组件按钮点击
    }
  }, 300)

  const handleOpenRights = debounce(() => {
    if (userInfo?.user_id) {
      onOpenRights()
    } else {
      openLogin(); // 触发子组件按钮点击
    }
  }, 300)

  useEffect(() => {
    if (location?.pathname === '/price') {
      setShowPrice(false)
    } else {
      setShowPrice(true)
    }
  }, [location?.pathname])

  useEffect(() => {
    if (location?.pathname === '/' ) {
      const queryParams = new URLSearchParams(location.search);
      if (queryParams?.get('inviteCode')) {
        setOpen(true);
        setIsLogin(false);
      }
    }
  }, [location?.pathname, location.search])

  // console.log(location?.pathname)
  const renderInviteUser = () => {
    let start = '专属邀请码 '
    let end = '，限时免费'
    const shareCode = userOtherInfo?.invite_code
    let linkstring = shareCode
      ? 'https://cemeta.cn/#/?inviteCode=' + shareCode
      : '未登录'
      
    // let linkstring = userOtherInfo?.invite_code_desc || '未登录'
    // const link = linkstring?.slice(linkstring.indexOf('http'))

    const handleCopy = async () => {
      try {
        const shareText = '森宇宙好绘AI PS插件\n先进AI设计功能+大额商单接单，免费体验!\n我的邀请码' + shareCode + '，点击链接注册→\n' + linkstring
        await navigator.clipboard.writeText(shareText);
        messageApi.open({
          type: 'success',
          content: '复制成功',
        });
        // console.log('复制成功');
        // 可选：提示用户
        // alert('已复制到剪贴板');
      } catch (err) {
        console.error('复制失败:', err);
        // 回退到老方法
        // fallbackCopy(text);
      }
    }
    return (
      <>
      {contextHolder}
      <div className="appHeader-invite-user">
        <div className="appHeader-invite-user-header">
          <span>邀请新用户</span>
        </div>
        <div className="appHeader-invite-user-body">
          <div className="appHeader-invite-user-body-text">
            <span>分享链接给新用户，当Ta通过链接成功注册后 
              <br /> 您可获得 <span className="appHeader-invite-text-number">100</span> 算力</span>        
          </div>
          <div className="appHeader-invite-user-body-link" style={{ cursor: 'pointer' }}>
            <div className="link-eclipse" style={{ color: '#717784', marginRight: '38px' }}>{linkstring}</div><span style={{ color: '#ffffff' }} onClick={handleCopy}>复制链接</span> 
          </div>
        </div>
        <div className="appHeader-invite-user-footer" onClick={() => navigate('/invite')}>
          <span>查看邀请列表</span>
        </div>
      </div>
      </>
    )
  }

  const handleOpenPopup = () => {
    setMoreVisible((state) => !state)
  }

  const MessageIconCom = ({ dot }: { dot?: boolean }) => {
    return <div className="message-icon">
      <img style={{ width: '20px', height: '20px' }} src={MessageIcon} alt="MessageIcon" />
      {dot && <div className="message-dot"></div>}
    </div>
  }

  const items: TabsProps['items'] = [
    {
      key: 'subscribe',
      label: '订阅计划管理',
      children: <div className="subscribe-container">
        <div className="subscribe-title">
          我的会员
        </div>
        <div className="subscribe-content">
          {/* 过期 */}
          <div className="subscribe-expired">
            <div className="subscribe-expired-left">
              <div className="subscribe-expired-icon">
              </div>
              {/* <div className="subscribe-expired-name">
                专业会员
              </div> */}
            </div>

            <div className="subscribe-expired-right">
              <div className="subscribe-expired-text">
                已过期时间
              </div>
              <div className="subscribe-expired-time">
                {dayjs("2025-11-31 18:00").format("YYYY-MM-DD-HH:mm")}
              </div>
            </div>
          </div>
          {/* 有效 */}
          <div className="subscribe-effective">
            <div className="subscribe-effective-left">
              <div className="subscribe-effective-icon">
              </div>
              {/* <div className="subscribe-effective-name">
                专业会员
              </div> */}
            </div>
            <div className="subscribe-effective-right">
              <div className="subscribe-effective-text">
                到期时间
              </div>
              <div className="subscribe-effective-time">
                {dayjs("2025-11-31 18:00").format("YYYY-MM-DD-HH:mm")}
              </div>
            </div>
          </div>
          {/* 未开通 */}
          <div className="subscribe-not-activated">
            <div className="subscribe-not-activated-desc">
              你还没有开通会员哦
            </div>
            <div className="subscribe-not-activated-button" onClick={handleJumpLink}>
              查看会员套餐
            </div>
          </div>
        </div>
      </div>
    },
    {
      key: 'record',
      label: '购买记录',
      children: <div className="record-container">
        <div className="record-list">
          <div className="record-item">
            <div className="record-item-head">
              <div className="record-item-icon">
              </div>
              <div className="record-item-name">
                专业会员
              </div>
            </div>
            <div className="record-item-desc">
              <div className="desc-item">
                <div className="desc-item-left">
                  订阅类型
                </div>
                <div className="desc-item-right">
                  单月购买
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  价格
                </div>
                <div className="desc-item-right">
                  {123}元
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  购买时间
                </div>
                <div className="desc-item-right">
                  {dayjs("2025-11-31 18:00").format("YYYY-MM-DD-HH:mm")}
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  订单编号
                </div>
                <div className="desc-item-right">
                  AJDJ_djjss-134435
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  支付方式
                </div>
                <div className="desc-item-right">
                  微信支付-134435
                </div>
              </div>
            </div>
          </div>
          <div className="record-item">
            <div className="record-item-head">
              <div className="record-item-icon">
              </div>
              <div className="record-item-name">
                专业会员
              </div>
            </div>
            <div className="record-item-desc">
              <div className="desc-item">
                <div className="desc-item-left">
                  订阅类型
                </div>
                <div className="desc-item-right">
                  单月购买
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  价格
                </div>
                <div className="desc-item-right">
                  {123}元
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  购买时间
                </div>
                <div className="desc-item-right">
                  {dayjs("2025-11-31 18:00").format("YYYY-MM-DD-HH:mm")}
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  订单编号
                </div>
                <div className="desc-item-right">
                  AJDJ_djjss-134435
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  支付方式
                </div>
                <div className="desc-item-right">
                  微信支付-134435
                </div>
              </div>
            </div>
          </div>
          <div className="record-item">
            <div className="record-item-head">
              <div className="record-item-icon">
              </div>
              <div className="record-item-name">
                专业会员
              </div>
            </div>
            <div className="record-item-desc">
              <div className="desc-item">
                <div className="desc-item-left">
                  订阅类型
                </div>
                <div className="desc-item-right">
                  单月购买
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  价格
                </div>
                <div className="desc-item-right">
                  {123}元
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  购买时间
                </div>
                <div className="desc-item-right">
                  {dayjs("2025-11-31 18:00").format("YYYY-MM-DD-HH:mm")}
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  订单编号
                </div>
                <div className="desc-item-right">
                  AJDJ_djjss-134435
                </div>
              </div>
              <div className="desc-item">
                <div className="desc-item-left">
                  支付方式
                </div>
                <div className="desc-item-right">
                  微信支付-134435
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  ];

  const messageTabsItem: TabsProps['items'] = [
    {
      key: 'message',
      label: '系统消息',
      children: <div className="message-tab">
        <div className="message-list">
          <div className="message-list-item">
            <div className="message-list-item-left">
              <div className="message-list-item-icon">
                <MessageIconCom/>
              </div>
              <div className="message-list-item-desc">
                <div className="list-item-desc-title">
                  【{"免费获取算力！"}】
                </div>
                <div className="list-item-desc-text">
                  点击查看详情
                </div>
              </div>
            </div>
            <div className="message-list-item-right">
              <div className="message-list-item-date">
                2025年11月7日
              </div>
            </div>
          </div>
          <div className="message-list-item">
            <div className="message-list-item-left">
              <div className="message-list-item-icon">
                <MessageIconCom />
              </div>
              <div className="message-list-item-desc">
                <div className="list-item-desc-title">
                  【{"免费获取算力！"}】
                </div>
                <div className="list-item-desc-text">
                  点击查看详情
                </div>
              </div>
            </div>
            <div className="message-list-item-right">
              <div className="message-list-item-date">
                2025年11月7日
              </div>
            </div>
          </div>
          <div className="message-list-item">
            <div className="message-list-item-left">
              <div className="message-list-item-icon">
                <MessageIconCom/>
              </div>
              <div className="message-list-item-desc">
                <div className="list-item-desc-title">
                  【{"免费获取算力！"}】
                </div>
                <div className="list-item-desc-text">
                  点击查看详情
                </div>
              </div>
            </div>
            <div className="message-list-item-right">
              <div className="message-list-item-date">
                2025年11月7日
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  ]
  

  const renderActivateVip = () => {
    return (
      <>
        <div className="appHeader-activate-vip">
          <div className="appHeader-activate-vip-title">
            <span>开通专业会员，可承接设计商单</span>
          </div>
          <div className="appHeader-activate-vip-desc">
            <div>
              ·每月 3000 + 企业商单
            </div>
             <div>
              ·客单价≥800 元
            </div>
             <div>
              ·免佣金
            </div>
             <div>
              ·提现秒到账
            </div>
          </div>
          <div className="appHeader-activate-vip-footer" onClick={() => navigate('/price')}>
            <div className="activate-vip-footer-button">
              <span>开通会员</span>
            </div>
          </div>
        </div>
      </>
    )
  }

  const donwloadContent = () => {
    const MAC_DOWNLOAD = "https://haohui-zips-1313090634.cos.ap-beijing.myqcloud.com/CeMetaHAOHUIV1.3.0%28MacOS%29.zip";
    const WIN_DOWNLOAD = "https://haohui-zips-1313090634.cos.ap-beijing.myqcloud.com/CeMetaHAOHUIV1.3.0%28Windows%29.zip";
    const handleMACDownload = debounce(() => {
      if (!isPc) {
        Dialog.alert({
          content: '请在电脑端打开！',
          onConfirm: () => {
            console.log('Confirmed')
          },
        })
        return
      }
      if (macRef.current) {
        macRef.current?.click();
        posthog?.capture('haohui_download', {
          type: 'mac',
          info: navigator?.userAgent
        });
      }
    }, 1000);

    const handleWINDownload = debounce(() => {
      if (!isPc) {
        Dialog.alert({
          content: '请在电脑端打开！',
          onConfirm: () => {
            console.log('Confirmed')
          },
        })
        return
      }
      if (winRef.current) {
        winRef.current?.click();
        posthog?.capture('haohui_download', {
          type: 'win',
          info: navigator?.userAgent
        });
      }
    }, 1000);
    return (
      <div className="header-action-download">
        <div className="action-download-container">
          <div className="action-download-item" onClick={handleMACDownload}>
            <span>
              mac 版本下载
            </span>
          </div>
          <div className="action-download-item" onClick={handleWINDownload}>
            <span>
              win 版本下载
            </span>
          </div>
        </div>
        <a
          ref={macRef}
          href={MAC_DOWNLOAD}
          style={{ visibility: "hidden" }}
        >
          {" "}
        </a>
        <a
          ref={winRef}
          href={WIN_DOWNLOAD}
          style={{ visibility: "hidden" }}
        >
          {" "}
        </a>
      </div>
  )};
  const computerPowerContent = () => {
    return (
      <div className="action-computer-container">
        <div className="action-computer-item" onClick={handleOpenCompute}>
          <span>
            购买算力
          </span>
        </div>
        {/* 12.1上线 暂时隐藏 */}
        {/* <div className="action-computer-item" onClick={handleOpen3}>
          <span>
            算力消耗明细
          </span>
        </div> */}
      </div>
  )};

  const messageContent = () => {
    // const operations = <div className="message-tabs-operation">
    //   全部标记为已读
    // </div>
    const operations = null
    return (
      <div className="message-content-container">
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                itemHoverColor: "#fff",
                itemSelectedColor: "#fff",
                inkBarColor: "#fff",
                itemColor:"#9c9c9c",
              },
            },
          }}
        >
           {/* 只有一个选项，暂时写死 */}
           {/* ant-tabs-nav */}
          <Tabs className="message-tabs" tabBarExtraContent={operations} activeKey={'message'} items={messageTabsItem} onChange={tabsOnChange} />
        </ConfigProvider>
      </div>
  )};
  const userInfoContent = () => {
    return (
      <div className="user-info-container">
        <div className="user-card">
          <div className="user-card-avatar">
            <img style={{ width: '48px', height: '48px' }} src={userOtherInfo?.avatar || AVATOR} alt="avator" />
          </div>
          <div className="user-card-info">
            <div className="user-card-info-title">
              <div className="user-name">
                {userOtherInfo?.name || "立即登录"}
              </div>
              <div className="user-vip-level">
                <img />
              </div>
            </div>
            <div className="user-card-info-expired">
              {userOtherInfo?.vip_expired_at ? "会员有效期: " + dayjs(userOtherInfo.vip_expired_at).format("YYYY-MM-DD") : "您还没有登录"}
            </div>
          </div>
        </div>
        <div className="user-vip-box">
          <img className="user-vip-bg" src={USER_VIP_BG} />
          {/* <div className="user-vip-desc">
            <div><span className="vip-desc-dot">·</span>尊享智能扩图</div>
            <div><span className="vip-desc-dot">·</span>高清修复等会员功能</div>
          </div> */}
          <div className="user-vip-renew" onClick={handleJumpLink}>
            订阅会员
          </div>
        </div>
        <div className="user-info-action">
          {/* <div className="user-info-action-item" onClick={handleOpenubscription}>
            <span>订阅管理</span>
          </div> */}
          <div className="user-info-action-item" onClick={handleOpenRights}>
            <span>权益兑换</span>
          </div>
        </div>
        <div className="user-info-footer" onClick={handleLogOut}>
          <div className="logout-button">
            退出登录
          </div>
        </div>
      </div>
    )
  };
  
  
  return (
    <>
    <div className={isPc ? 'app-header' : 'mobile-app-header'} style={cssStyle} >
      {
        isPc
          ? (
            <>
            <div className="header-left" ref={headerLeft}>
              <div className="cemeta-logo" onClick={() => navigate('/')}>
                <img src={LOGO} alt="logo" />
              </div>
              {/* <div className="divider"></div> */}
              <div className="title-container">
              {/* <div className="meta-title">森宇宙好绘</div> */}
              <div className="header-action">
                <div className="header-action-item" onClick={() => navigate('/')}>
                  <span>首页</span>
                </div>
                 <div className="header-action-item" onClick={() => navigate('/commercial-order')}>
                  <span>设计商单平台</span>
                </div>
                <div className="header-action-item">
                  <a href={BROARD_LINK} target="_blank">案例广场</a>
                </div>
                <div className="header-action-item" >
                  <a href={LESSON_LINK} target="_blank">使用教程</a>
                </div>
                <div className="header-action-item" onClick={handleJumpLink}>
                  <span>价格</span>
                </div>
                <div className="header-action-item">
                  <Popover 
                    content={donwloadContent}  
                    placement="bottomRight"
                    color="#2B303B"
                    arrow={false}
                  >
                     <span>下载</span>
                  </Popover>
                </div>
            </div>
            </div>
            </div>
            <div className="header-right" ref={headerRight}>
              {
                userInfo?.user_id
                  ? (
                    <>
                      {/* 12.1上线 暂时隐藏 */}
                      {/* <div className="header-activate-vip"  style={{ marginRight: '8px' }}>
                        <Popover
                          getPopupContainer={(trigger: any) => trigger.parentElement}
                          content={renderActivateVip()}
                          placement="bottomRight"
                          color="#2B303B"
                          arrow={false}
                        >
                          <img className="activate-vip-img" src={ACTIVATE_VIP} alt="activate vip" />
                        </Popover>
                      </div> */}
                      <div className="header-invite" style={{ marginRight: '8px' }}>
                        <Popover
                          getPopupContainer={(trigger: any) => trigger.parentElement}
                          content={renderInviteUser()}
                          placement="bottomRight"
                          color="#2B303B"
                          arrow={false}
                        >
                          <img className="invite-img" src={IVITE_USER} alt="invite user" />
                        </Popover>
                      </div>
                      
                      <div className="user-info">
                        <Popover
                            getPopupContainer={(trigger: any) => trigger.parentElement}
                            content={computerPowerContent}
                            placement="bottomRight"
                            color="#2B303B"
                            arrow={false}
                          >
                          <div className="coin-info">
                            <div className="coin-icon">
                              <img style={{ width: '20px', height: '20px' }} src={PAY} alt="paycount" />
                            </div>
                            
                              <span className="coin-count">{payCountObj?.recharge?.pay + payCountObj?.subscribe?.pay + payCountObj?.gift?.pay + payCountObj?.old?.pay}算力</span>
                          </div>
                        </Popover>
                        {/* 12.1上线 暂时隐藏 */}
                        {/* <Popover
                          getPopupContainer={(trigger: any) => trigger.parentElement}
                          content={messageContent}
                          placement="bottomRight"
                          color="#2B303B"
                          arrow={false}
                        >
                          <div className="header-message">
                            <MessageIconCom dot={true}/>
                          </div>
                        </Popover> */}
                        
                        <Popover
                          content={userInfoContent}
                          placement="bottomRight"
                          arrow={false}
                          color="#2B303B"
                        >
                          <img style={{ width: '48px', height: '48px' }} src={userOtherInfo?.avatar || AVATOR} alt="avator" />
                        </Popover>
                      </div> 
                    </>
                  )
                  : (
                    <>
                      <div className="sign-up" style={{ marginRight: '8px' }} onClick={() => handleShowLogin(false)}>
                        <span>注册</span>
                      </div>
                      <div className="sign-in" onClick={() => handleShowLogin(true)}>
                        <span>登录</span>
                      </div>
                    </>
                  )
              }
            </div>
            </>
          )
          : (
            <>
              <div className="header-left">
                <div className="cemeta-logo" onClick={() => navigate('/')}>
                  <img style={isPc ? {} : { width: '141px', height: 'auto' }} src={LOGO} alt="logo"  />
                </div>
                {/* <div className="divider"></div>
                <div className="mobile-title-container">
                  <div className="mobile-meta-title">森宇宙好绘</div>
                </div> */}
              </div>
              <div className="header-right" onClick={handleOpenPopup}>
                <MenuUnfoldOutlined style={{ fontSize: '1.5em' }} />
                <Popup
                  position='top'
                  visible={moreVisible}
                  onMaskClick={() => {
                    setMoreVisible(false)
                  }}
                  bodyStyle={{ backgroundColor: 'transparent', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
                  <div className="header-right-dropdown">
                    {/* 把onclick事件加上 */}
                    <div style={{display: 'flex', flexDirection: 'column', marginTop: '60px' }}>
                      {
                        location?.pathname !== '/'
                          ? <div className="header-right-dropdown-item" onClick={() => navigate('/')}>首页</div>
                          : null
                      }
                      <div className="header-right-dropdown-item" onClick={() => { navigate('/price'); setMoreVisible(false) }}>
                        价格
                      </div>
                    </div>
                    
                    <div className="header-right-dropdown-item" onClick={() => { window.open(LESSON_LINK); setMoreVisible(false) }}>
                      使用教程
                    </div>
                    <div className="header-right-dropdown-item" onClick={() => { window.open(BROARD_LINK); setMoreVisible(false) }}>
                      案例广场
                    </div>
                    {
                      userInfo?.user_id
                        ? (
                          <>
                            {
                              location?.pathname !== '/invite'
                                ? (
                                  <div className="header-right-dropdown-item" onClick={() => { navigate('/invite'); setMoreVisible(false) }}>
                                    邀请好友
                                  </div>
                                )
                                : null
                            }
                            <div className="header-right-dropdown-item" onClick={() => { handleLogOut(); setMoreVisible(false) }}>
                              退出登录
                            </div>
                          </>
                        )
                        : (
                          <>
                            <div className="header-right-dropdown-item" onClick={() =>{ handleShowLogin(true); setMoreVisible(false)}}>
                              登录
                            </div>
                            <div className="header-right-dropdown-item" onClick={() => {handleShowLogin(false); setMoreVisible(false)}}>
                              注册
                            </div>
                          </>
                        )
                    }  
                    {/* <List.Item prefix={<img style={{ width: '24px', height: '24px' }} src={LOGO} alt="logo" />} onClick={() => { navigate('/'); setMoreVisible(false) }}>
                      首页
                    </List.Item>
                    <List.Item prefix={<i className="ri-price-tag-3-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { navigate('/price'); setMoreVisible(false) }}>
                      价格
                    </List.Item>
                    <List.Item prefix={<i className="ri-book-2-fill" style={{ fontSize: '24px' }}></i> } onClick={() => { window.open(LESSON_LINK); setMoreVisible(false) }}>
                      使用教程
                    </List.Item>
                    <List.Item prefix={<i className="ri-gallery-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { window.open(BROARD_LINK); setMoreVisible(false) }}>
                      案例广场
                    </List.Item>
                    {
                      userInfo?.user_id
                        ? (
                          <>
                            {
                              location?.pathname !== '/invite'
                                ? (
                                  <List.Item prefix={<i className="ri-user-add-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { navigate('/invite'); setMoreVisible(false) }}>
                                    邀请好友
                                  </List.Item>
                                )
                                : null
                            }
                            <List.Item prefix={<i className="ri-logout-box-r-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { handleLogOut(); setMoreVisible(false) }}>
                              退出登录
                            </List.Item>
                          </>
                        )
                        : (
                          <>
                            <List.Item prefix={<i className="ri-user-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { handleShowLogin(true); setMoreVisible(false) }}>
                              登录
                            </List.Item>
                            <List.Item prefix={<i className="ri-user-smile-fill" style={{ fontSize: '24px' }}></i>} onClick={() => { handleShowLogin(false); setMoreVisible(false) }}>
                              注册
                            </List.Item>
                          </>
                        )
                    } */}
                  </div>
                </Popup>
              </div>
            </>
            
          )
      }
      
    </div>
    <Modal
        className="header-model"
        width={'430px'}
        title={null}
        footer={null}
        open={open}
        maskClosable={false}
        onCancel={() => setOpen(false)}
      >
        {
          isLogin 
            ? <Login open={open} propsSetOpen={(value: boolean) => setOpen(value)} propsSetIsLogin={(value: boolean) => setIsLogin(value)} /> 
            : <Register propsSetIsLogin={(value: boolean) => setIsLogin(value)} />
        }
      </Modal>
      {/* 兑换权益弹框 */}
      <Modal 
        className="rights-redemption-modal"
        width={'380px'}
        title={null}
        footer={null}
        open={rightsRedemptionOpen}
        maskClosable={false}
        onCancel={onCancelRights}
      >
        <div className="rights-redemption-title">
          <span>权益兑换</span>
        </div>
        <div className="rights-user-info">
          <div className="rights-user-info-avatar">
            <img src={userOtherInfo?.avatar || AVATOR} alt="avator" />
          </div>
          <div className="rights-user-info-name"> 
            {userOtherInfo?.name}
          </div>
        </div>
        <div className="rights-redemption-body">
          <Input className="rights-redemption-input" placeholder="请输入兑换码，区分大小写" value={rightsCode} onChange={(e)=>{setRightsCode(e.currentTarget.value)}}/>
          <div className="rights-redemption-button" onClick={exchange}>
            立即兑换
          </div>
        </div>
        <div className="rights-redemption-footer">
          <div className="rights-redemption-desc">
            兑换须知<br />
            <br />
            1.一个兑换码仅能兑换一次，请谨慎兑换;<br />
            2.兑换码存在有效期，过期无法兑换，请尽快使用；一般有效期为一年，<br />
            具体以兑换码发放方的信息为准;<br />
            3.兑换码需登录后才可兑换，请先登录再兑换;<br />
            4.会员&积分权益有效时间与兑换时长一致；兑换会员赠送的积分值<br />
            以兑换天数进行折算;<br />
            5.本内容为虚拟产品，兑换后不可退款；<br />
            6.兑换过程中如遇到问题，请微信联系CeMeta小助手，专属客服将会处理;<br />
            7.兑换权益流程最终解释，归森宇宙好绘所有。<br />
          </div>
        </div>
      </Modal>
      <Modal 
        className="subscription-modal"
        // width={'380px'}
        title={null}
        footer={null}
        open={subscriptionOpen}
        maskClosable={false}
        onCancel={onCancelSubscription}
      >
        <div>
          <div className="subscription-title">
            订阅管理
          </div>
          <div>
            <ConfigProvider
              theme={{
                components: {
                  Tabs: {
                    itemHoverColor: "#fff",
                    itemSelectedColor: "#fff",
                    inkBarColor: "#fff",
                    itemColor:"#9c9c9c",
                  },
                },
              }}
            >
              <Tabs className="subscription-tabs" activeKey={tabKey} items={items} onChange={tabsOnChange} />
            </ConfigProvider>
          </div>
        </div>
      </Modal>
      {/* 购买算力 */}
      <BuyComputeModal  open={buyComputeOpen} setOpen={setBuyComputeOpen} payCountObj={payCountObj} userOtherInfo={userOtherInfo} handleOpenCompute={handleOpen3} />
      {/* 算力消耗 */}
      <ComputeUsageModal open={computeUsageOpen} onCannel={onCancelComputeUsage} payCountObj={payCountObj} />
    </>
  );
});

export default Header;
